window.addEventListener('load', function () {
  // ページ内リンクのスムーススクロール処理
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const href = this.getAttribute('href');

      // href="#"の場合はページトップへスクロール
      const target = href === '#' ? document.documentElement : document.querySelector(href);
      if (!target) return;

      const targetPosition = target.getBoundingClientRect().top;
      const offsetPosition = window.pageYOffset;
      const targetOffset = targetPosition + offsetPosition;

      window.scrollTo({
        top: targetOffset,
        behavior: 'smooth'
      });
    });
  });
}, false);